// extracted by mini-css-extract-plugin
export default {"cardClass1":"OrderStatusChart_cardClass1__r7IAp","action":"OrderStatusChart_action__-gKtG"};